var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.getEmbededUrl)?_c('iframe',{staticClass:"media-preview",attrs:{"id":"mediaPreview","type":"text/html","width":"480","height":"183","src":_vm.getEmbededUrl,"frameborder":"0"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }